export default async function GetUserPermissionsApi(positionId = null) {
  let res = "";
  try {
    const token = "Bearer " + localStorage.getItem("authToken");
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: token,
      },
    };

    // Build URL with optional positionId query parameter
    let url = `${process.env.REACT_APP_API_URL}v1/position-features/user-permissions`;
    if (positionId) {
      url += `?positionId=${positionId}`;
    }

    await fetch(url, requestOptions)
      .then((response) => response.json())
      .then((response) => {
        res = response;
      })
      .catch((error) => {
        console.error("Error getting user permissions: ", error);
        res = error;
      });
  } catch (error) {
    console.error(error);
    res = error;
  }

  return res;
}
